import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
    return <div>Loading...</div>;
}

const Dashboard = Loadable({
    loader: () => import('./views/Dashboard'),
    loading: Loading,
});

const AdvertiserCommissionReport =  Loadable({
    loader: () => import('./views/Reports/AdvertiserCommissionReport'),
    loading: Loading,
});

const PublisherCommissionReport =  Loadable({
    loader: () => import('./views/Reports/PublisherCommissionReport'),
    loading: Loading,
});

const routes = [
    {path: '/dashboard', name: 'Dashboard', component: Dashboard},
    {path: '/reports/advertiser-commission-report', name: 'Advertiser Commission Report', component: AdvertiserCommissionReport},
    {path: '/reports/publisher-commission-report', name: 'Publisher Commission Report', component: PublisherCommissionReport},
];

export default routes;
